/* eslint-disable */

const RSS_URL = 'https://falkor-cda.bastian.globo.com/feeds/54b54793-2f40-4934-8795-637b3a2a7d2b/posts/page/1';
const NUMBER_OF_NEWS = 10;
const NUMBER_OF_NEWS_TO_SHOW = 3;

/**
 * Removes all HTML tags inside a string
 * @param {string} string The string to use
 * @returns {string} The string without the html tags
 */
function stripHTMLTags(string) {
  return string.replace(/<(?:[^>=]|='[^']*'|="[^"]*"|=[^'"][^\s>]*)*>/g, '');
}

/**
 * Retrieve the top new from the URL
 * @param {Number} numberOfNews number of news to be retrieved
 * @param {String} url url of the feed
 * @return {JSON} formatted json
 */
function retrieveTopNews(numberOfNews, url) {
  return fetch(url)
    .then(data => data.json())
    .then(json => json.items)
    .then(items => items.slice(0, numberOfNews))
    .then(items => items.map(item => item.content))
    .then(items => items.map(item => ({
      title: stripHTMLTags(item.title),
      url: stripHTMLTags(item.url),
      image: item.image ? stripHTMLTags(item.image.sizes.V.url) : null,
      summary: stripHTMLTags(item.summary),
    })));
}

/**
 * calculates the sum of the NUMBER_OF_NEWS_TO_SHOW elements height and apply to parent
 * @param {HTMLElement} parentEL element in which max height will be applied
 */
function applyMaxHeight(parentEL) {
  const height = [].slice.call(document.querySelectorAll('.list-item.news'))
    .slice(0, NUMBER_OF_NEWS_TO_SHOW)
    .reduce((acc, curr) => acc + curr.offsetHeight, 0);
  parentEL.style.maxHeight = height;
}

/**
 * Creates the HTMLElements to be appended
 * @param {JSON} newsList JSON object with the news to be appended
 * @param {String} parentEL parent Element
 */
function renderNews(newsList, parentEL) {
  let chars = 50;
  const defaultImgLink = 'https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/gcn_static/static/templates/especiais/verao_espetacular/assets/images/verao_espetacular__logo.png';

  newsList.forEach((news) => {
    const newsEL = `
    <li class="list-item news">
      <a class="link news__img-link" href="${news.url}" style="background-image: url('${news.image || defaultImgLink}')">
      </a>
      <div class="news__content">
        <a class="link" href="${news.url}" title="${news.title}">
          <h3 class="news__title title">${news.title.substring(0, chars).trim()}...</h3>
        </a>
        <p class="news__description paragraph">${news.summary.substring(0, chars).trim()}...</p>
      </div>
    </li>`;
    parentEL.insertAdjacentHTML('beforeend', newsEL);
  });

  applyMaxHeight(parentEL);
}

/** executes the feed retrieval */
export default function initFeed() {
  const frameEL = document.querySelector('.frame--feed');
  const parentEL = frameEL.querySelector('#newsfeed');
  const btn = frameEL.querySelector('[data-button="see-more"]')
  retrieveTopNews(NUMBER_OF_NEWS, RSS_URL)
    .then(data => renderNews(data, parentEL))
    .catch(error => console.error(error)); //eslint-disable-line

  btn.addEventListener('click', () => {
      frameEL.classList.toggle('expanded');
      btn.querySelector('.see-more-text').textContent = 'Menos Notícias'
    });
}



// WEBPACK FOOTER //
// local_static/templates/especiais/verao_espetacular/assets/scripts/feed.js